import { AnyAction, combineReducers } from "redux";
import { AppState } from "../../types";
import * as shared from "../shared";
import { acceleratorQuotaStats } from "./acceleratorQuotaStats";
import { batchedRun } from "./batchedRun";
import { defaultSessionSettings } from "./defaultSessionSettings";
import { dismissedBanners } from "./dismissedBanners";
import { editor } from "./editor";
import { enableLsp } from "./enableLsp";
import { entities } from "./entities";
import { externalSourceData } from "./externalSourceData";
import { layout } from "./layout";
import { lifecycle } from "./lifecycle";
import { local } from "./local";
import { modal } from "./modal";
import { notebook } from "./notebook";
import { terminal } from "./terminal";
import { timer } from "./timer";
import { toolbar } from "./toolbar";
import { userSecrets } from "./userSecrets";

/** Apply reducers for each key in the AppState. */
const combinedReducers = combineReducers<AppState>({
  ...shared,
  batchedRun,
  dismissedBanners,
  editor,
  enableLsp,
  entities,
  acceleratorQuotaStats,
  layout,
  lifecycle,
  local,
  modal,
  notebook,
  terminal,
  timer,
  toolbar,
  userSecrets,
  defaultSessionSettings,
  externalSourceData,
});

/** The root reducer for the app store. */
export const app = (state: AppState | undefined, action: AnyAction) => {
  return combinedReducers(state, action);
};
